/**
 * Regionalisierung Page - Tabbed view for regional classifications
 */

import { useState } from 'react'
import { Map, Briefcase, Compass, Hexagon } from 'lucide-react'
import { ClassificationTable } from './ClassificationTable'
import type { ClassificationType } from '../types'
import { cn } from '../../lib/utils'

interface TabConfig {
  id: ClassificationType
  label: string
  icon: React.ReactNode
}

const TABS: TabConfig[] = [
  { id: 'spatial-planning-regions', label: 'Raumordnungsregionen', icon: <Map className="w-4 h-4" /> },
  { id: 'labor-market-regions', label: 'Arbeitsmarktregionen', icon: <Briefcase className="w-4 h-4" /> },
  { id: 'travel-regions', label: 'Reisegebiete', icon: <Compass className="w-4 h-4" /> },
  { id: 'urbanization-areas', label: 'Verdichtungsräume', icon: <Hexagon className="w-4 h-4" /> },
]

export function RegionalisierungPage() {
  const [activeTab, setActiveTab] = useState<ClassificationType>('spatial-planning-regions')

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Regionalisierung</h1>
        <p className="text-gray-500 mt-1">Regionale Gliederungen aus GV100NAD</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex gap-1" aria-label="Tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors',
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <ClassificationTable classificationType={activeTab} />
    </div>
  )
}
